module.exports = __webpack_public_path__ + "static/media/FileCircle.3d5d42de.svg";